import { render, staticRenderFns } from "./Tinting.vue?vue&type=template&id=39294f16"
import script from "./Tinting.vue?vue&type=script&lang=js"
export * from "./Tinting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports